<ng-container *ngIf="show.modalStay && !show.expiredSessionModal">
  <app-modal-container
    class="modal-stay"
    [bigSize]="false"
    [buttons]="modalButtons"
    (dismissButtonClicked)="logOut()"
    (applyButtonClicked)="apply()">
    <app-all-icons
      [iconNameAndStyling]="'sand-clock.svg;icon-size-8'"></app-all-icons>
    <div class="whitespace-1"></div>
    <ng-container *ngIf="is.sessionExpired">
      <span class="title">Your session has expired</span>
      <span class="subtitle">
        You’ve been inactive for a while. For your security we <br>
        automatically sign you out.
      </span>
    </ng-container>
    <ng-container *ngIf="!is.sessionExpired">
      <span class="title">Your session is about to end.</span>
      <span class="subtitle">
        You’ve been inactive for a while. For your security,<br>
        we’ll automatically sign you out in approximately...
      </span>
    </ng-container>
    <span
      *ngIf="!is.sessionExpired"
      class="title"
      [class.red-11]="is.redTitleEnabled">
      {{ title }}
    </span>
    <div *ngIf="!is.sessionExpired" class="whitespace-1"></div>
  </app-modal-container>
</ng-container>

@if (show.expiredSessionModal){
  <app-modal-expired-session
    (goToLoginEmitter)="goToLogin()"
  />
}
